// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1v-KG","validationTips":"StatementDescriptor_validationTips__-0Uvi"};